module.exports = __webpack_public_path__ + "img/logo.235bc38a.png";